import type { TMessengerErpLayoutMode } from '@xometry/ui';
import { ESideOverlayType, type TSideOverlayContext } from 'stores/SideOverlay/SideOverlayStore';

/** Layout passed to MFE on REINITIALIZE_MC — must match host overlay vs compact when `forceClassic` is active. */
export const getEffectiveErpMessengerUserPreferenceForReinit = (
  overlayContext: TSideOverlayContext,
  storedUserPreference: TMessengerErpLayoutMode,
): TMessengerErpLayoutMode => {
  if (
    overlayContext.type === ESideOverlayType.Messenger &&
    overlayContext.messengerLayoutPresentation === 'forceClassic'
  ) {
    return 'classic';
  }

  return storedUserPreference;
};
